// USED TO BRING USER TO "YOU ARE NOT AUTHORIZED PAGE"
export class NotAuthorizedError extends Error {
  constructor(message, options) {
    super(message, { cause: JSON.stringify(options ?? {}) });
  }

  get exceptionCause() {
    return JSON.parse(this.cause);
  }

  toString() {
    return `${this.name}: ${this.message} ${this.cause}`;
  }
}

export default NotAuthorizedError;
